<div class="tab-body">
  <div class="tab-head">
    <div>
      <h3>Branches</h3>
      <p>Locations / offices belonging to this client. One branch is the default.</p>
    </div>
    <p-button label="Add Branch" icon="pi pi-plus" (onClick)="openAdd()" />
  </div>

  <p-table [value]="rows()" [loading]="loading()" dataKey="id" [rows]="10"
    [paginator]="rows().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
    <ng-template pTemplate="header">
      <tr>
        <th>Branch Code</th>
        <th>Branch Name</th>
        <th>Contact</th>
        <th>GST No</th>
        <th class="ta-c">Default</th>
        <th class="ta-c">Active</th>
        <th class="ta-r">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-r>
      <tr>
        <td class="mono">{{ r.branchCode || '—' }}</td>
        <td class="name">
          {{ r.branchName }}
          @if (r.city) { <small class="sub-line"><i class="pi pi-map-marker"></i> {{ r.city }}</small> }
        </td>
        <td>
          <div class="contact-cell">
            @if (r.contactPerson) { <span class="ct-person"><i class="pi pi-user"></i> {{ r.contactPerson }}</span> }
            @if (r.email) { <span class="ct-line"><i class="pi pi-envelope"></i> {{ r.email }}</span> }
            @if (r.mobile) { <span class="ct-line mono"><i class="pi pi-phone"></i> {{ r.mobile }}</span> }
            @if (!r.contactPerson && !r.email && !r.mobile) { <span class="muted">—</span> }
          </div>
        </td>
        <td class="mono">{{ r.gstNo || '—' }}</td>
        <td class="ta-c">
          @if (r.isDefault) {
            <p-tag value="Default" severity="info" icon="pi pi-star-fill" />
          } @else {
            <span class="muted">—</span>
          }
        </td>
        <td class="ta-c">
          <span class="active-toggle" (click)="toggleActive(r)" pTooltip="Click to toggle">
            <p-tag [value]="r.isActive ? 'Active' : 'Inactive'"
              [severity]="r.isActive ? 'success' : 'secondary'" />
          </span>
        </td>
        <td class="ta-r actions">
          <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
            pTooltip="Edit" (onClick)="openEdit(r)" />
          @if (!r.isDefault) {
            <p-button icon="pi pi-star" [rounded]="true" [text]="true" severity="secondary"
              pTooltip="Make Default" (onClick)="makeDefault(r)" />
          }
          <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
            pTooltip="Delete" (onClick)="remove(r)" />
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">
          <div class="state"><i class="pi pi-sitemap"></i>
            <p>No branches yet. Click "Add Branch" to create one.</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [closable]="true" [dismissableMask]="false"
  [header]="editing() ? 'Edit Branch' : 'Add Branch'" styleClass="menu-dialog"
  [style]="{ width: '680px' }" [breakpoints]="{ '680px': '94vw' }">
  <form [formGroup]="form" class="menu-form">
    <div class="grid-2">
      <div class="field">
        <label>Branch Code <span class="req">*</span></label>
        <input pInputText type="text" formControlName="branchCode" placeholder="BR-001"
          (input)="upper('branchCode')" [readonly]="editing()" />
        @if (form.get('branchCode')?.touched && form.get('branchCode')?.invalid) {
          <small class="err">Branch code is required</small>
        }
      </div>
      <div class="field">
        <label>Branch Name <span class="req">*</span></label>
        <input pInputText type="text" formControlName="branchName" placeholder="Head Office" />
        @if (form.get('branchName')?.touched && form.get('branchName')?.invalid) {
          <small class="err">Branch name is required</small>
        }
      </div>
      <div class="field">
        <label>Contact Person</label>
        <input pInputText type="text" formControlName="contactPerson" placeholder="John Doe" />
      </div>
      <div class="field">
        <label>Email</label>
        <input pInputText type="email" formControlName="email" placeholder="branch@acme.com" />
        @if (form.get('email')?.touched && form.get('email')?.invalid) {
          <small class="err">Enter a valid email</small>
        }
      </div>
      <div class="field">
        <label>Mobile</label>
        <input pInputText type="text" formControlName="mobile" placeholder="9876543210" />
        @if (form.get('mobile')?.touched && form.get('mobile')?.invalid) {
          <small class="err">Enter a valid 10-digit mobile</small>
        }
      </div>
      <div class="field">
        <label>GST No</label>
        <input pInputText type="text" formControlName="gstNo" placeholder="27ABCDE1234F1Z5"
          (input)="upper('gstNo')" />
        @if (form.get('gstNo')?.touched && form.get('gstNo')?.invalid) {
          <small class="err">GST must be 15 characters</small>
        }
      </div>
    </div>

    <div class="field">
      <label>Address</label>
      <textarea class="form-textarea" rows="2" formControlName="address" placeholder="Street, area"></textarea>
    </div>

    <div class="grid-3">
      <div class="field">
        <label>City</label>
        <input pInputText type="text" formControlName="city" placeholder="Pune" />
      </div>
      <div class="field">
        <label>State</label>
        <input pInputText type="text" formControlName="state" placeholder="MH" />
      </div>
      <div class="field">
        <label>Country</label>
        <input pInputText type="text" formControlName="country" placeholder="India" />
      </div>
      <div class="field">
        <label>Pincode</label>
        <input pInputText type="text" formControlName="pincode" placeholder="411001" />
        @if (form.get('pincode')?.touched && form.get('pincode')?.invalid) {
          <small class="err">Enter a valid 6-digit pincode</small>
        }
      </div>
    </div>

    <div class="field">
      <label>Regional Offices (RO) <span class="req">*</span></label>
      <p-multiSelect formControlName="roIds" [options]="roOptions()" optionLabel="label"
        optionValue="value" [filter]="true" display="chip"
        placeholder="Select regional offices for this branch" appendTo="body" [showClear]="true" />
      @if (form.get('roIds')?.touched && form.get('roIds')?.invalid) {
        <small class="err">Tag at least one regional office (RO) to this branch.</small>
      } @else if (!roOptions().length) {
        <small class="err">This client has no regional offices yet — create ROs first, then tag them here.</small>
      } @else {
        <small class="muted">Members enrolled at an RO inherit its master policy. An RO can belong to multiple branches.</small>
      }
    </div>

    <div class="switch-grid">
      <label class="switch-row">
        <p-toggleSwitch formControlName="isDefault" />
        <span>Default branch <small>(only one per client)</small></span>
      </label>
      <label class="switch-row">
        <p-toggleSwitch formControlName="isActive" />
        <span>Active</span>
      </label>
    </div>

    <div class="modal-actions">
      <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
      <p-button [label]="saving() ? 'Saving…' : 'Save'" icon="pi pi-check" (onClick)="save()"
        [disabled]="saving()" [loading]="saving()" />
    </div>
  </form>
</p-dialog>
